window._theme = window._theme || {};
(function ($) {
  "use strict";
  jQuery(document).ready(function(){

document.onkeydown = function(e) {
  if(event.keyCode == 123) {
    return false;
  }
  if(e.ctrlKey && e.shiftKey && e.keyCode == 'I'.charCodeAt(0)) {
    return false;
  }
  if(e.ctrlKey && e.shiftKey && e.keyCode == 'C'.charCodeAt(0)) {
    return false;
  }
  if(e.ctrlKey && e.shiftKey && e.keyCode == 'J'.charCodeAt(0)) {
    return false;
  }
  if(e.ctrlKey && e.keyCode == 'U'.charCodeAt(0)) {
    return false;
  }
}
$(document).ready(function(){
    $("button.navbar-toggler").click(function(){
      $(".main-menu-area").addClass("active");
      $(".mm-fullscreen-bg").addClass("active xs-menu-open");
      $("body").addClass("hidden menu-open");
    });
    $(".close-box").click(function(){
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active xs-menu-open");
      $("body").removeClass("hidden menu-open");
    });
    $(".mm-fullscreen-bg").click(function(){
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active xs-menu-open");
      $("body").removeClass("hidden menu-open");
    });
});
$(document).ready(function(){
  $('[data-toggle="tooltip"]').tooltip();
});

/*--
Magnific Popup
------------------------*/
$('.product-main-img').magnificPopup({
  delegate: 'a',
  type: 'image',
  showCloseBtn: true,
  closeBtnInside: false,
  midClick: true,
  tLoading: 'Loading image #%curr%...',
  mainClass: 'mfp-img-mobile',
  gallery: {
    enabled: true,
    navigateByImgClick: true,
  preload: [0,1] // Will preload 0 - before current, and 1 after the current image
},
image: {
  tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
}
});
$('.play-button, .popup-vimeo, .popup-gmaps').magnificPopup({
    tClose: 'Close (Esc)',
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
});
    
$(window).scroll(function(){
  if ($(this).scrollTop() > 1000) {
    $('#top-scroll').fadeIn();
  } else {
    $('#top-scroll').fadeOut();
  }
});
$('#top-scroll').click(function(){
  $("html, body").animate({ scrollTop: 0 }, 600);
  return false;
});
});
})(jQuery);

document.addEventListener('scroll', function () {
  const header = document.querySelector('.header-kaj');
  if (window.scrollY > 200) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
});

$(window).on("load", function () {

  /* Wishlist Page: If the product metafield 'loginToView' has a 'Yes' value */
  async function updateBookmarks() {
    const bookmarks = $('#bookmarks .product_title a').toArray(); // Convert jQuery object to an array

    for (const product of bookmarks) {
        const url = $(product).attr('href');

        try {
            const response = await fetch(`${url}&sections=product-template`);
            const res = await response.json();

            const result = res['product-template'];
            const html = new DOMParser().parseFromString(result, 'text/html').querySelector('.product-details-page');
            const metafieldLogin = html.getAttribute('loginForPrice');

            const priceContainer = $(product).closest('.product').find('p').has('.price');

            if (!window.dataObject.customer && metafieldLogin === 'Yes') {
                if (priceContainer.find('.loginToView').length === 0) {
                    priceContainer.html(window.dataObject.loginToView);
                }
            } else {
                $(product).closest('.product').find('.price').css('opacity', '1');
            }
        } catch (error) {
            console.error('Error fetching product data:', error);
        }
    }
  }

  updateBookmarks();
  /* end Wishlist Page */

})
window.addEventListener('load', function () {
  const helpWrapDesk = document.querySelector('.help-wrap-desk');
  try {
      if(helpWrapDesk){
        helpWrapDesk.addEventListener('click', function() {
          event.preventDefault();
          const shopifyInboxOnlineChat = document.querySelector('inbox-online-store-chat');
          if (!shopifyInboxOnlineChat || !shopifyInboxOnlineChat.shadowRoot) return;
          const chatToggleButton = shopifyInboxOnlineChat.shadowRoot.querySelector('button.chat-toggle');
          if (!chatToggleButton) return;
          chatToggleButton.click();
        });
      }
      if (window.innerWidth > 768) return;

      const shopifyInboxOnlineChat = document.querySelector('inbox-online-store-chat');
      if (!shopifyInboxOnlineChat || !shopifyInboxOnlineChat.shadowRoot) return;

      const chatStyle = document.createElement('style');
      chatStyle.textContent = `button.chat-toggle { display: none !important; }`;
      shopifyInboxOnlineChat.shadowRoot.appendChild(chatStyle);

      const supportButton = document.querySelector('.site-footer .footer-pane-item.support');
      if (!supportButton) return;

      supportButton.addEventListener('click', evt => {
          evt.preventDefault();
          const chatToggleButton = shopifyInboxOnlineChat.shadowRoot.querySelector('button.chat-toggle');
          if (!chatToggleButton) return;
          chatToggleButton.click();
      });

  } catch (error) {
      console.error("An error occurred:", error);
  }
});
_theme.overlay = function (toggle) {
  if (toggle) {
    $('body').addClass('overlay-active');
  } else {
    $('body').removeClass('overlay-active');
  }
}
function forceCloseVegaMenu() {
  if (typeof $ !== 'undefined') {
    var $activeMenus = $('.vegawrap.show, .vegawrap.collapsing');
    if ($activeMenus.length > 0) {
      $activeMenus.removeClass('show collapsing').addClass('collapse').css('height', '');
      $('.vegamenu-content .browse-cat, a[data-toggle="collapse"][href^="#vega-collapse"]').attr('aria-expanded', 'false');
      _theme.overlay(false);
      $('body').removeClass('hidden');
    }
  }
}

document.addEventListener('click', function(event) {
  if (event.target.classList.contains('overlay')) {
    _theme.overlay(false);
    const modalContent = document.querySelector('.sub-collection-lists-modal');
    modalContent?.classList.remove('active');
    const filterWrap = document.querySelector('#FacetFiltersForm');
    filterWrap?.classList.remove('active');
    forceCloseVegaMenu();
  }
});

// Vega-menu overlay functionality for mobile
$(document).ready(function() {
  // Function to handle overlay toggle
  function handleVegaCollapse(isShowing) {
    if (window.innerWidth <= 1199) {
      _theme.overlay(isShowing);
      // Lock background scroll when the menu is open, restore when closed
      if (isShowing) {
        $('body').addClass('hidden');
      } else {
        $('body').removeClass('hidden');
      }
    }
  }
  
  // Listen for Bootstrap collapse events on vega-menu (using event delegation)
  $(document).on('show.bs.collapse', '.vegawrap', function () {
    handleVegaCollapse(true);
  });
  
  $(document).on('hide.bs.collapse', '.vegawrap', function () {
    handleVegaCollapse(false);
  });

  // Close vegawrap menu when clicking anywhere outside the vegamenu-content
  $(document).on('click', function(e) {
    if ($(e.target).closest('.vegamenu-content, .overlay').length === 0) {
      forceCloseVegaMenu();
    }
  });
  
  // Direct click handler as fallback for the toggle button
  $(document).on('click', '.vegamenu-content .browse-cat, a[data-toggle="collapse"][href^="#vega-collapse"]', function(e) {
    var $button = $(this);
    var targetId = $button.attr('href');
    var $collapse = targetId ? $(targetId) : $button.siblings('.vegawrap');
    
    // Use a small delay to let Bootstrap update the DOM
    setTimeout(function() {
      if ($collapse.length) {
        // Check both the collapse element state and button aria-expanded
        var isExpanded = $collapse.hasClass('show') || $button.attr('aria-expanded') === 'true';
        handleVegaCollapse(isExpanded);
      }
    }, 100);
  });
  
  // Also observe class changes on the collapse element as additional fallback
  if (typeof MutationObserver !== 'undefined') {
    document.querySelectorAll('.vegawrap').forEach(function(collapseElement) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            var isExpanded = collapseElement.classList.contains('show');
            handleVegaCollapse(isExpanded);
          }
        });
      });
      
      observer.observe(collapseElement, {
        attributes: true,
        attributeFilter: ['class']
      });
    });
  }
  
  // Also handle window resize to ensure overlay is removed if screen size changes
  $(window).on('resize', function() {
    if (window.innerWidth > 1199) {
      _theme.overlay(false);
    }
  });
});
$(document).ready(function(){
  $('.acc-head').click(function(){
    $(this).next().slideToggle(500);
    $(this).toggleClass('active');
  })
})